<template>
    <div class="form-row">
        <form-label
            v-if="!! label"
            :id="id"
        >
            {{ label }}

            <template v-if="hasHelp" #help>
                <slot name="help">
                    <form-help>
                        {{ help }}
                    </form-help>
                </slot>
            </template>
        </form-label>

        <slot />

        <form-error
            v-if="!! error"
            :error="error"
        />
    </div>
</template>
<script>
import FormError from '@/components/Form/FormError';
import FormHelp from '@/components/Form/FormHelp';
import FormLabel from '@/components/Form/FormLabel';

export default {
    components: {
        FormError,
        FormHelp,
        FormLabel,
    },

    props: {
        id: {
            type: String,
            default: null,
        },
        label: {
            type: String,
            default: null,
        },
        help: {
            type: String,
            default: null,
        },
        error: {
            type: [String, Boolean],
            default: null,
        },
    },

    computed: {
        /**
         * Indicates whether row have help or not.
         *
         * @returns {boolean} Check result.
         */
        hasHelp() {
            return !! this.help || !! this.$slots.help;
        },
    },
};
</script>
